import type { SxProps, Theme } from '@mui/material';

export const header: SxProps<Theme> = {
  py: 4,
  px: 3,
};

export const headerTitle: SxProps<Theme> = {
  mb: 2,
};

export const headerDescription: SxProps<Theme> = {
  maxWidth: 800,
};

export const container: SxProps<Theme> = {
  px: 3,
  flexGrow: 1,
  pb: 10,
};

export const sectionTitle: SxProps<Theme> = {
  mb: 3,
};

export const tabsContainer: SxProps<Theme> = {
  borderBottom: 1,
  borderColor: 'divider',
  mb: 3,
};

export const tabs: SxProps<Theme> = {
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    color: 'text.secondary',
    '&.Mui-selected': {
      color: '#b388ff',
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#b388ff',
  },
};

export const loadingContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  py: 4,
};

export const errorAlert: SxProps<Theme> = {
  mb: 3,
};

export const tabPanel: SxProps<Theme> = {
  pt: 3,
};

export const credentialsContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

export const credentialCard: SxProps<Theme> = {
  // No specific styles needed for the card wrapper
};

export const acrCloudSection: SxProps<Theme> = {
  mt: 6,
}; 